import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { ShareButtons } from "@/components/ShareButtons";
import { SITE_URL } from "@/lib/share";
import { Gift } from "lucide-react";

const SHARE_QUOTE = "I'm using XAUUSD AI Terminal — AI-powered gold (XAUUSD) trading signals from US macro data. Join with my link 👇";

export function ReferralDialog({ trigger }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (open) api.get("/referral").then((r) => setData(r.data)).catch(() => {});
  }, [open]);

  const link = data ? `${SITE_URL}/?ref=${data.code}` : "";

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent data-testid="referral-dialog" className="bg-[#111827] border-white/10 text-[#F9FAFB]">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            <Gift size={20} className="text-[#F59E0B]" /> Refer & Earn
          </DialogTitle>
          <DialogDescription className="text-xs text-[#9CA3AF]">
            Share your link. Every friend who subscribes to Pro gives you a <strong className="text-[#F59E0B]">free month</strong>.
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-2 gap-3 mb-2">
          <div className="glass rounded-xl p-3 text-center">
            <div className="font-mono-num text-2xl font-bold text-[#10B981]">{data?.count ?? 0}</div>
            <div className="text-[10px] uppercase tracking-wider text-[#6B7280] font-mono-num">Referrals</div>
          </div>
          <div className="glass rounded-xl p-3 text-center">
            <div className="font-mono-num text-2xl font-bold text-[#F59E0B]">{data?.months_earned ?? 0}</div>
            <div className="text-[10px] uppercase tracking-wider text-[#6B7280] font-mono-num">Free months</div>
          </div>
        </div>

        <div className="flex items-center gap-2 mb-1">
          <input data-testid="referral-link" readOnly value={link}
            className="flex-1 bg-[#0A0D14] border border-white/10 rounded-lg px-3 py-2 text-xs font-mono-num text-[#9CA3AF]" />
        </div>

        <div className="text-[11px] text-[#9CA3AF] mb-1">Share &amp; earn a free month:</div>
        <ShareButtons url={link} quote={SHARE_QUOTE} />
      </DialogContent>
    </Dialog>
  );
}
